/**
 * Role → landing shell. THE role-separation switchboard (Wave D):
 * gate staff live in the gate-ops shell; everyone else (residents,
 * committee members, admins) lands in the resident tabs — committee and
 * admin get their extra screens from inside it.
 */
import type { SessionUser } from '@bero/api-client';

export function homeFor(user: Pick<SessionUser, 'role'> | null): string {
  if (user && (user.role === 'GUARD' || user.role === 'FRONTDESK')) return '/guard';
  if (user && user.role === 'PLATFORM_ADMIN') return '/platform';
  return '/(tabs)/home';
}
